// src/auth/PrivateRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

const PrivateRoute = ({ children }) => {
	const { isAuthenticated, loading } = useAuth();
	const location = useLocation();

	// ⏳ Wait until auth state is resolved
	if (loading) {
		return (
			<div className="flex h-[60vh] items-center justify-center text-slate-600">
				Checking session...
			</div>
		);
	}

	// 🔒 Not authenticated → redirect to login
	if (!isAuthenticated) {
		return (
			<Navigate
				to="/login"
				replace
				state={{ from: location.pathname }}
			/>
		);
	}

	// ✅ Authenticated → render page
	return <>{children}</>;
};

export default PrivateRoute;
